<template>
  <div class="round-summary">
    <BListGroup class="mb-5">
      <BListGroupItem
        v-for="(playerPhrase, phraseIndex) in phrasesByPlayer"
        :key="`phrase-${phraseIndex}`"
      >
        <PhraseWithUserText
          :phrase="playerPhrase.phrase"
          :texts="playerPhrase.texts"
          class="mb-2"
          :style="{ display: 'block' }"
        />
        <span class="ml-2">richtig getippt: {{ playerPhrase.guessedBy }}</span>
      </BListGroupItem>
    </BListGroup>
    <div
      v-for="(player, playerIndex) in phrasesByPlayers"
      :key="`player-${playerIndex}`"
      class="ml-4 mb-4"
    >
      <h5>von {{ player.name }}</h5>
      <BListGroup>
        <BListGroupItem
          v-for="(playerPhrase, phraseIndex) in player.phrases"
          :key="`phrase-${playerIndex}-${phraseIndex}`"
        >
          <PhraseWithUserText
            :phrase="playerPhrase.phrase"
            :texts="playerPhrase.texts"
            class="mb-2"
            :style="{ display: 'block' }"
          />
          <span class="ml-2">getippt von: {{ playerPhrase.guessedBy.length === 0 ? 'niemandem' : playerPhrase.guessedBy.join(', ') }}</span>
        </BListGroupItem>
      </BListGroup>
    </div>
  </div>
</template>

<script>
import resolvePlayerName from '@/shared/mixins/resolvePlayerName';

import PhraseWithUserText from './PhraseWithUserText.vue';

export default {
  name: 'RoundSummary',
  components: { PhraseWithUserText },
  props: {
    round: {
      type: Object,
      required: true,
    },
  },
  mixins: [resolvePlayerName],
  computed: {
    phrasesByPlayer() {
      if (this.$store.state.phrases == null) {
        return null;
      }
      return this.round.phrases.map((phrase) => {
        // noinspection TypeScriptValidateTypes
        const phraseText = this.$store.state.phrases[phrase.phraseId];
        const currentPhrase = {
          phrase: phraseText,
          texts: phrase.playerInputs[this.round.player].text,
          guessedBy: [],
        };
        Object.keys(phrase.playerInputs).forEach((player) => {
          if (
            player === this.round.player
            || phrase.playerInputs[player].guess !== this.round.player
          ) {
            return;
          }
          currentPhrase.guessedBy.push(this.resolvePlayerName(player));
        });
        if (currentPhrase.guessedBy.length === 0) {
          currentPhrase.guessedBy = 'keiner';
        } else {
          currentPhrase.guessedBy = currentPhrase.guessedBy.join(', ');
        }
        return currentPhrase;
      });
    },
    phrasesByPlayers() {
      if (this.$store.state.phrases == null) {
        return null;
      }
      const phrasesByPlayers = {};
      this.round.phrases.forEach((phrase, phraseIndex) => {
        Object.keys(phrase.playerInputs).forEach((player) => {
          if (player === this.round.player) {
            return;
          }

          // set player text
          if (phrasesByPlayers[player] == null) {
            phrasesByPlayers[player] = {
              name: player,
              phrases: [],
            };
          }
          if (phrasesByPlayers[player].phrases[phraseIndex] == null) {
            phrasesByPlayers[player].phrases[phraseIndex] = {
              guessedBy: [],
            };
          }
          // noinspection TypeScriptValidateTypes
          phrasesByPlayers[player].phrases[phraseIndex].phrase = this.$store.state.phrases[phrase.phraseId];
          phrasesByPlayers[player].phrases[phraseIndex].texts = phrase.playerInputs[player].text;

          // check who was guessed
          const { guess } = phrase.playerInputs[player];
          if (guess === this.round.player) {
            return;
          }
          if (phrasesByPlayers[guess] == null) {
            phrasesByPlayers[guess] = {
              name: guess,
              phrases: [],
            };
          }
          if (phrasesByPlayers[guess].phrases[phraseIndex] == null) {
            phrasesByPlayers[guess].phrases[phraseIndex] = {
              guessedBy: [],
            };
          }
          phrasesByPlayers[guess].phrases[phraseIndex].guessedBy.push(this.resolvePlayerName(player));
        });
      });
      return Object.values(phrasesByPlayers);
    },
  },
};
</script>

<style scoped>

</style>
